import React from 'react';
import { Link } from 'react-router';
import '../styles/Tile.scss';

const Tile = ({ project, projectId }) => (
  <Link to={`/project/${projectId}`} className={`Tile ${project.tile.grid}`}>
    <div className='bg' style={{ background: `url(${project.tile.bgImage})` }} />
    <div className='title'>
      <h1>{project.title}</h1>
      <div className='title-bg' />
    </div>
  </Link>
);

Tile.propTypes = {
  projectId: React.PropTypes.string.isRequired,
  project: React.PropTypes.object.isRequired
};

export default Tile;



// WEBPACK FOOTER //
// ./src/components/Tile.js